import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    OnInit,
    Input,
    ChangeDetectorRef,
    ViewEncapsulation,
    inject,
    output,
    viewChild,
    effect,
    input,
    computed,
    signal,
} from "@angular/core";
import { S25ObjectSearchResultsListComponent } from "./s25.object.search.results.list.component";
import { ObjectSearchAvail } from "./object.search.avail";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { Nullable } from "../../pojo/Util";
import { LoginStore } from "../../stores/login.store";
import { SearchStore } from "../../stores/search.store";
import { Bind } from "../../decorators/bind.decorator";
import { Debounce } from "../../decorators/debounce.decorator";
import { AngBridgeUtil } from "../../util/ang.bridge.util";
import { S25Util } from "../../util/s25-util";
import { SearchService } from "../../services/search/search.service";
import { Item } from "../../pojo/Item";
import { SearchDropdownApi, ReloadAndSelectParams } from "../s25-dropdown/single-select/s25.search.dropdown.component";
import { DropDownItem } from "../../pojo/DropDownItem";
import { SearchUtil } from "../../services/search/s25.search.util";
import { ComplexSearch, Search } from "../s25-ql/search";
import { NotificationService } from "../../services/notification.service";
import { PreferenceService } from "../../services/preference.service";
import { S25Const } from "../../util/s25-const";
import { SpaceService } from "../../services/space.service";
import { ResourceService } from "../../services/resource.service";
import { S25Event } from "../s25-event/EventMicroI";
import { S25Reservation } from "../s25-event/ReservationI";
import { AvailLocationItems, AvailResourceItems, UrlParams } from "./s25.object.search.util";
import { SubscriberSetUtil } from "../../services/search/subscriber-sets/subscriber.set.util";
import { S25SubscriberSetService } from "../../services/search/subscriber-sets/s25.subscriber.set.service";
import { Eval25Service } from "../../services/eval25.service";
import { S25Array } from "../../util/core/s25.array";

@TypeManagerDecorator("s25-ng-object-search")
@Component({
    selector: "s25-ng-object-search",
    host: {
        "[class.object-search--event-form]": "isEventForm",
    },
    template: `
        @if (isInitReady()) {
            <div class="flex filter-toggles">
                @if (!hideAutoLoad) {
                    <s25-ng-preference-toggle
                        [prefName]="itemTypeId === 4 ? 'auto_load_starred_sp' : 'auto_load_starred_rs'"
                        [modelValue]="autoLoad"
                        [label]="'Auto-Load Starred'"
                        [inline]="!isEventForm"
                        [trueLabel]="'Yes'"
                        [falseLabel]="'No'"
                    />
                }

                @if (itemTypeId === 4) {
                    @if (!hideHideConflicts) {
                        <s25-ng-checkbox
                            [(value)]="hideConflicts"
                            (valueChange)="updatePreference('25L_rsrvwiz_hide_unavail_sp', $event)"
                        >
                            Hide Conflicts
                        </s25-ng-checkbox>
                    }
                    @if (!hideHideRequestConflicts) {
                        <s25-ng-checkbox
                            [(value)]="hideRequestConflicts"
                            (valueChange)="updatePreference('25L_rsrvwiz_hide_unavail_sp_req', $event)"
                        >
                            Hide Request Conflicts
                        </s25-ng-checkbox>
                    }
                    @if (!hideEnforceHeadcount) {
                        <s25-ng-checkbox
                            [(value)]="enforceHeadcount"
                            (valueChange)="updatePreference('25L_rsrvwiz_enforce_headcount', $event)"
                        >
                            Enforce Headcount
                        </s25-ng-checkbox>
                    }
                    @if (systemHasLocationScore) {
                        <s25-ng-checkbox
                            [(value)]="showLocationScore"
                            (valueChange)="updatePreference('ShowLocationScore', $event)"
                        >
                            Show Location Satisfaction
                        </s25-ng-checkbox>
                    }
                }
            </div>

            <div class="flex c-margin-top--single c-margin-bottom--single">
                @if (store.isKeywordSearching()) {
                    <s25ql-search-simple-input-dropdown
                        [type]="$any(itemTypeId)"
                        [criteria]="$safeNavigationMigration(store.keywordSearch()?.criteria)"
                        (criteriaChange)="store.setCriteria($event)"
                        [fixedOnBody]="!isEventForm"
                    />
                }
                @if (!hideSavedSearchDropdown) {
                    <span class="searchDropdown">
                        <s25-ng-search-dropdown
                            [initialSearch]="autoLoadInitialSearch"
                            [additionalSearches]="prefSearchAdditional()"
                            [hasFav]="true"
                            [value]="store.fromSavedSearch()"
                            (valueChange)="selectSearch($event)"
                            [itemTypeId]="itemTypeId"
                            [allowNonQueryId]="true"
                            [searchEnabled]="true"
                            [placeholder]="'Saved Searches (optional)'"
                            [ariaLabel]="savedSearchAriaLabel"
                        ></s25-ng-search-dropdown>
                    </span>
                }
                <span>
                    <s25-ng-ql-search-input
                        [value]="store.text() ?? ''"
                        (valueChange)="store.setTextInput($event)"
                        [type]="$any(itemTypeId)"
                        [placeholder]="'Search ' + (store.typeName() + 's' | titlecase)"
                        (search)="onSearch()"
                        (errorMessage)="store.setError($event)"
                        [disabled]="!!store.savedSearch()"
                        [disableAi]="disableAi()"
                    ></s25-ng-ql-search-input>
                </span>
                <span class="buttons">
                    <button class="c-textButton borderRight" (click)="onReset()">Reset</button>
                    <button class="aw-button aw-button--primary" (click)="onSearch()">Search</button>
                </span>
            </div>

            @if (store.errorMessage()) {
                <div class="errorMessage">
                    <pre class="ngBold">Error: {{ store.errorMessage() }}</pre>
                </div>
            }

            @if (showResultsList) {
                <s25-ng-object-search-results-list
                    [itemTypeId]="itemTypeId!"
                    [params]="params"
                    [occ]="occ"
                    [profileId]="profileId"
                    [eventId]="eventId"
                    [showLocationScore]="showLocationScore"
                    [hideConflicts]="hideConflicts"
                    [hideRequestConflicts]="hideRequestConflicts"
                    [isTempSearch]="!!store.rawQLSearch()"
                    [selectedItems]="selectedItems"
                    [event]="event"
                    [isEventForm]="isEventForm"
                    [hideInstructions]="hideInstructions"
                    [excludeExpress]="excludeExpress"
                    [profilePrefSearch]="profilePrefSearch()"
                    [savedSearchChosen]="store.fromSavedSearch()"
                    [suppressedDatetimeFields]="suppressedDatetimeFields()"
                    (refreshF)="refreshF.emit($event)"
                    (cancelled)="cancelled.emit()"
                    (resultsLoaded)="resultsLoaded.emit($event)"
                    (starredSearchEmpty)="onStarredSearchEmpty()"
                ></s25-ng-object-search-results-list>
            }
        }
    `,
    styleUrls: ["./s25.object.search.component.scss"],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
    providers: [SearchStore],
})
export class S25ObjectSearchComponent implements OnInit {
    @Input() itemTypeId?: Item.Ids.Location | Item.Ids.Resource;
    @Input() profileId?: number;
    @Input() eventId?: number;
    @Input() occ?: S25Reservation;
    @Input() selectedItems?: number[] = [];
    @Input() event?: S25Event;
    @Input() expectedCount?: Nullable<number>;
    /**
     * optional list of occurrence date ranges (sorted by start)
     */
    @Input() dates?: { startDt: string | Date; endDt: string | Date; occUUID?: number }[];
    @Input() isEventForm: boolean = false;
    @Input() hideAutoLoad: boolean = false;
    @Input() hideSavedSearchDropdown: boolean = false;
    /**
     * Profile "Associated Locations/Resources" pre-defined search from the event
     * form hydrant (`sp_query_id` / `rs_query_id`). Takes priority over starred
     * auto-load when present.
     */
    readonly profilePrefSearch = input<DropDownItem<string>>();
    /** Rule-driven recommended search shown in the dropdown when Use Recommended is off. */
    readonly recommendedPrefSearch = input<DropDownItem<string>>();
    readonly suppressedDatetimeFields = input<string[]>([]);
    @Input() defaultHideConflicts: boolean = false;
    @Input() hideHideConflicts: boolean = false;
    @Input() checkHideRequestConflicts: boolean = false;
    @Input() hideHideRequestConflicts: boolean = false;
    @Input() checkEnforceHeadcount: boolean = false;
    @Input() hideEnforceHeadcount: boolean = false;
    @Input() hideInstructions: boolean = false;
    @Input() excludeExpress: boolean = false;
    /**
     * Extra criteria appended to the URL on every search (alongside the
     * keyword/QL/saved-search params). When this is set, an initial search runs
     * automatically so results show without requiring user input.
     */
    @Input()
    set extraCriteria(value: string | undefined) {
        if (value === this._extraCriteria) return;
        const hadPrevious = this._extraCriteria != null;
        this._extraCriteria = value;
        if (!this.isInitReady()) return;
        if (hadPrevious && this.showResultsList) {
            Debounce.flush(this.setParams);
            void this.refreshCurrentSearch();
        } else {
            this.setParams();
        }
    }
    get extraCriteria(): string | undefined {
        return this._extraCriteria;
    }
    /** @deprecated TODO: make ai search work in event form and occurrence modal */
    readonly disableAi = input(false);
    private _extraCriteria?: string;
    readonly refreshF = output<ObjectSearchRefresh>();
    readonly cancelled = output<void>();
    readonly beforeSearch = output<void>();
    readonly resultsReset = output<void>();
    readonly resultsLoaded = output<number>();

    readonly store = inject(SearchStore);
    readonly login = inject(LoginStore);

    readonly isInitReady = signal(false);
    query: string = "";
    autoLoad: boolean = true;
    hideConflicts: boolean;
    hideRequestConflicts: boolean;
    enforceHeadcount: boolean;
    showLocationScore: boolean;
    systemHasLocationScore: boolean;
    showResultsList: boolean = false;
    params: UrlParams = {};
    refresh: boolean = false;
    disabled: boolean = false;
    autoLoadInitialSearch?: ReloadAndSelectParams;
    /** Make sure we only check for starred absence once. see {@link onStarredSearchEmpty} */
    private noStarredObjectsChecked = false;

    readonly prefSearchAdditional = computed(
        () => {
            const additional: DropDownItem<string>[] = [];
            const profile = this.profilePrefSearch();
            const recommended = this.recommendedPrefSearch();
            if (profile?.val) additional.push(profile);
            if (recommended?.val && !additional.some((item) => item.txt === recommended.txt)) {
                additional.push(recommended);
            }
            return additional;
        },
        { equal: S25Util.array.isEqualDeep },
    );
    private lastRecommendedPrefVal?: string;
    private prefSearchAdditionalSynced = false;

    get savedSearchAriaLabel(): string {
        return this.itemTypeId === Item.Ids.Location ? "Saved location searches" : "Saved resource searches";
    }

    readonly searchResultsList = viewChild(S25ObjectSearchResultsListComponent);

    constructor(
        private elementRef: ElementRef,
        private changeDetector: ChangeDetectorRef,
    ) {
        AngBridgeUtil.init(this);
        effect(() => this.syncPrefSearchAdditionalFromSignals());
        effect(() => {
            if (!this.isInitReady()) return;
            // TODO: have search.store not fall back to invalid types, rather than catching it here
            if (this.store.typeId() !== this.itemTypeId && this.itemTypeId && this.showResultsList) {
                this.showResultsList = false;
                this.changeDetector.markForCheck();
            }
        });
    }

    private syncPrefSearchAdditionalFromSignals() {
        if (!this.isInitReady()) return;

        this.prefSearchAdditional();

        const recommended = this.recommendedPrefSearch();
        const recommendedVal = recommended?.val;
        const previousRecommendedVal = this.lastRecommendedPrefVal;

        const shouldReloadDropdown = this.prefSearchAdditionalSynced;
        this.prefSearchAdditionalSynced = true;
        this.lastRecommendedPrefVal = recommendedVal;

        if (!shouldReloadDropdown || !this.itemTypeId) return;

        const chosenSearch = this.store.fromSavedSearch();
        const valChanged = previousRecommendedVal !== recommendedVal;
        const shouldRerunRecommendedSearch =
            !!recommendedVal && valChanged && this.isRecommendedSearchSelected(chosenSearch, recommended);

        if (shouldRerunRecommendedSearch) {
            void SearchDropdownApi.reloadSearches(this.elementRef.nativeElement, {
                itemTypeId: this.itemTypeId,
                isFullReload: false,
                property: "val",
                value: recommendedVal,
            }).then(() => this.executeSearch());
            return;
        }

        SearchDropdownApi.reloadSearches(this.elementRef.nativeElement, {
            itemTypeId: this.itemTypeId,
            isFullReload: false,
        });
    }

    private isRecommendedSearchSelected(
        chosenSearch: DropDownItem<number> | undefined,
        recommended: DropDownItem<string>,
    ): boolean {
        if (!chosenSearch) return false;
        const label = recommended.txt;
        if (chosenSearch.txt === label || chosenSearch.itemName === label) return true;
        const idParamPrefix = this.itemTypeId === Item.Ids.Location ? "&space_id=" : "&resource_id=";
        return String(chosenSearch.val ?? "").startsWith(idParamPrefix);
    }

    async ngOnInit() {
        // Initialize store with item type
        if (this.itemTypeId) {
            this.store.setItemType(this.itemTypeId as Search.TypeId);
        }

        const prefs = await PreferenceService.getPreferences([
            "25L_rsrvwiz_enforce_headcount",
            "25L_rsrvwiz_hide_unavail_sp",
            "25L_rsrvwiz_hide_unavail_sp_req",
            "ShowLocationScore",
            "auto_load_starred_sp",
            "auto_load_starred_rs",
        ]);

        if (this.itemTypeId === Item.Ids.Location) {
            this.systemHasLocationScore = await Eval25Service.displayLocationScore();
            this.autoLoad = !this.hideAutoLoad && S25Util.toBool(prefs.auto_load_starred_sp?.value);
            this.hideConflicts =
                this.defaultHideConflicts || S25Util.toBool(prefs["25L_rsrvwiz_hide_unavail_sp"]?.value);
            this.hideRequestConflicts =
                this.checkHideRequestConflicts || S25Util.toBool(prefs["25L_rsrvwiz_hide_unavail_sp_req"]?.value);
            this.enforceHeadcount =
                this.checkEnforceHeadcount || S25Util.toBool(prefs["25L_rsrvwiz_enforce_headcount"]?.value);
            this.showLocationScore = this.systemHasLocationScore && S25Util.toBool(prefs.ShowLocationScore?.value);
        } else {
            this.autoLoad = !this.hideAutoLoad && S25Util.toBool(prefs.auto_load_starred_rs?.value);
        }

        // Profile associated-locations/resources search takes priority over starred auto-load.
        if (!this.hideAutoLoad && this.profilePrefSearch()?.val) {
            this.autoLoad = true;
            this.autoLoadInitialSearch = {
                property: "val",
                value: this.profilePrefSearch()?.val,
                itemTypeId: this.itemTypeId!,
            };
        } else if (this.autoLoad) {
            this.query = "&favorite=T";
            const search = this.itemTypeId === Item.Ids.Location ? "&spaces_favorite=T" : "&resource_favorite=T";
            this.autoLoadInitialSearch = {
                property: !Number(search) ? "val" : "itemId",
                value: search,
                itemTypeId: this.itemTypeId!,
            };
        }

        this.isInitReady.set(true);
        this.changeDetector.detectChanges();

        // If we mounted with a fixed criteria filter (e.g. recommended-items
        // mode) and didn't auto-load a starred search, trigger an initial
        // setParams so results render without requiring user interaction.
        if (this._extraCriteria && !this.autoLoad) this.setParams();
    }

    private starredAutoLoadPrefName(): "auto_load_starred_sp" | "auto_load_starred_rs" {
        return this.itemTypeId === Item.Ids.Location ? "auto_load_starred_sp" : "auto_load_starred_rs";
    }

    /**
     * Starred auto-load already ran and the availability search returned null.
     * Confirm there are no favorites at all before turning the preference off.
     * Only clear the search when the chosen query is the starred one.
     */
    async onStarredSearchEmpty() {
        if (this.noStarredObjectsChecked || !this.autoLoad) return;

        const hasStarred = await this.hasStarredItems();
        this.noStarredObjectsChecked = true;
        if (hasStarred || !this.autoLoad) return;

        this.autoLoad = false;
        if (this.chosenSearchIsStarred()) this.onReset();
        await PreferenceService.setPreference(this.starredAutoLoadPrefName(), "F");
        const kind = this.itemTypeId === Item.Ids.Location ? "locations" : "resources";
        NotificationService.post(
            `You don't have any starred ${kind}, so Auto-Load Starred was turned off.`,
            10 * S25Const.ms.sec,
        );
    }

    private chosenSearchIsStarred(): boolean {
        const chosen = this.store.fromSavedSearch();
        const favoriteQuery = this.itemTypeId ? Search.favorite[this.itemTypeId] : undefined;
        const value = String(chosen?.val ?? "");
        return value === favoriteQuery || value === "&favorite=T";
    }

    /** List-scope favorite query. An empty page means the user has nothing starred. */
    private async hasStarredItems(): Promise<boolean> {
        const query = "&favorite=T&page_size=1";
        if (this.itemTypeId === Item.Ids.Location) {
            const data = await SpaceService.getSpacesBySearchQuery(query, undefined, "list");
            return S25Array.forceArray(data?.spaces?.space).length > 0;
        }
        const data = await ResourceService.getResourcesBySearchQuery(query, undefined, "list");
        return S25Array.forceArray(data?.resources?.resource).length > 0;
    }

    clearError() {
        this.store.clearError();
    }

    async selectSearch(search: Nullable<DropDownItem<number>>) {
        await this.store.chooseSavedSearch(search);
        return this.executeSearch();
    }

    async onSearch() {
        if (this.validate()) {
            return this.executeSearch();
        }
    }

    private async executeSearch() {
        if (this.store.advancedSearch() || this.store.rawQLSearch()) {
            await this.buildQueryFromComplex(this.store.complexSearch());
        } else if (this.store.keywordSearch()) {
            if (!this.store.validateKeywordSearch()) return;
            this.setParams();
        } else if (this.store.savedSearch()) {
            const savedSearch = this.store.savedSearch()!.chosen;
            this.query = String(savedSearch.val);
            this.setParams();
        } else if (this._extraCriteria) {
            this.setParams();
        }
        Debounce.flush(this.setParams);
    }

    private async buildQueryFromComplex(search: ComplexSearch) {
        if (!this.itemTypeId) return;

        if (SearchService.usesSubscriptionSets(this.itemTypeId)) {
            try {
                const filter = SubscriberSetUtil.modelToSubscriberSetFilter(search.model);
                const name = `temp_${S25Util.generateQuickGUID()}`;
                const set = await S25SubscriberSetService.createSet(name, this.itemTypeId, filter);
                this.query = `&subscriber_key=${set.id}`;
            } catch (err: any) {
                this.store.setError(err.message || "Error creating contact search");
                return;
            }
        } else {
            const { id } = await SearchUtil.createSearch(search.model, {}, this.itemTypeId);
            this.query = "&query_id=" + id;
        }
        this.setParams();
    }

    @Bind
    onReset() {
        this.store.reset();
        // Reset component-specific display state
        this.query = "";
        this.resultsReset.emit();
        if (this.isEventForm) {
            this.params = {};
            this.showResultsList = false;
        }
        this.changeDetector.markForCheck();
    }

    reloadSearches(queryId: number) {
        const data = { itemTypeId: this.store.typeId(), property: "itemId", value: queryId };
        SearchDropdownApi.reloadSearches(this.elementRef.nativeElement, data);
    }

    refreshSearch() {
        if (this.store.savedSearch()) return; // No changes have been made
        return this.store.convertToQL();
    }

    validate(): boolean {
        this.store.clearError();
        if (this.store.qlSearch()) {
            const { error } = this.store.qlSearch()!;
            if (error) {
                this.store.setError(error);
                return false;
            } else {
                return true;
            }
        } else if (this.store.keywordSearch()) {
            return this.store.validateKeywordSearch();
        }
        return !this.store.errorMessage();
    }

    updatePreference(prefName?: string, val?: any) {
        if (!prefName) return Promise.resolve();
        return PreferenceService.setPreference(prefName, val).then(() => {
            if (prefName === "ShowLocationScore") this.setParams();
        });
    }

    async refreshCurrentSearch(): Promise<void> {
        if (!this.showResultsList) {
            return this.onSearch();
        }
        this.setParams(false);
        Debounce.flush(this.setParams);
        this.changeDetector.detectChanges();
        await this.searchResultsList()?.onRefresh();
    }

    @Debounce(300) // Avoid double calls
    setParams(hardRefresh = true) {
        this.beforeSearch.emit();

        let permStart: string | Date | undefined;
        let permEnd: string | Date | undefined;
        let lastOccParams = "";
        if (this.dates?.length) {
            permStart = this.dates[0].startDt;
            permEnd = this.dates[0].endDt;
            if (this.dates.length > 1) {
                const last = this.dates[this.dates.length - 1];
                lastOccParams =
                    "&last_occ_start_dt=" +
                    S25Util.date.toS25ISODateTimeStr(last.startDt) +
                    "&last_occ_end_dt=" +
                    S25Util.date.toS25ISODateTimeStr(last.endDt);
            }
        } else {
            const occStart = this.occ?.setupStart || this.occ?.eventStart;
            permStart = occStart;
            permEnd = occStart;
        }
        const criteria =
            "&scope=extended" +
            "&can_schedule=T" +
            "&perm_start_dt=" +
            S25Util.date.toS25ISODateTimeStr(permStart) +
            "&perm_end_dt=" +
            S25Util.date.toS25ISODateTimeStr(permEnd) +
            lastOccParams +
            this.store.criteriaParams() +
            (this._extraCriteria ?? "");

        let include: string | any = "";

        if (this.itemTypeId === Item.Ids.Location) {
            this.showLocationScore ? (include = "&include=layouts+ratings") : (include = "&include=layouts");
            if (this.excludeExpress) include = include + "+direct_schedule";
            if (this.enforceHeadcount) include = include + "&min_default_capacity=" + (this.expectedCount || 0);
        }

        let query = "";

        if (["&spaces_favorite=T", "&resource_favorite=T"].indexOf(this.query) > -1) {
            query = "&favorite=T";
        } else if (["&spaces_direct=T&spaces_min_ols=R&spaces_can_assign=T"].indexOf(this.query) > -1) {
            query = this.query.replace(
                "&spaces_direct=T&spaces_min_ols=R&spaces_can_assign=T",
                "&direct=T&spaces_min_ols=R&spaces_can_assign=T",
            );
        } else {
            query = this.query;
        }

        if (this.store.keywordParam() !== "") query = "";
        this.params = {
            inputParam: this.store.keywordParam(),
            query: query,
            criteria: criteria,
            include: include,
        };

        if (hardRefresh) {
            if (this.refresh) {
                this.showResultsList = false;
                this.changeDetector.detectChanges();
            } else {
                this.refresh = true;
            }

            this.showResultsList = true;
            this.changeDetector.detectChanges();
        }
    }
}

export interface ObjectSearchRefresh {
    items: ObjectSearchAvail.AddedItem[];
    profileRange?: { setup: string; takedown: string };
}
